import React from "react";

import * as S from "./Accordion.styles";

export type AccordionListHeaderProps =
  | {
      children: React.ReactNode;
      onCheckedChange?: null;
    }
  | {
      children: React.ReactNode;
      isValid?: boolean;
      checked: boolean;
      onCheckedChange?: (checked: boolean) => void;
      error?: string;
      forId?: string;
      id?: string;
      required?: boolean | undefined;
      disabled?: boolean | undefined;
    };

/**
 * List header component for Accordion
 */
export const AccordionListHeader = (props: AccordionListHeaderProps) => {
  return (
    <S.ListHeaderLayout>
      <S.Trigger aria-label="trigger-accordion-list">
        {props.onCheckedChange ? (
          <S.ListCheckboxItem
            id={props.id}
            forId={props?.forId}
            checked={props.checked}
            onCheckedChange={props.onCheckedChange}
            label={<>{props.children}</>}
            isValid={props.isValid}
            error={props.error}
            required={props.required}
            disabled={props.disabled}
          />
        ) : (
          <S.FakeLabel>{props.children}</S.FakeLabel>
        )}
        <S.Chevron aria-label="chevron-accordion-list" />
      </S.Trigger>
    </S.ListHeaderLayout>
  );
};
